import React from 'react';
import CurrencyConverter from './CurrencyConverter';
import UnitConverter from './UnitConverter';

const ConversionPanel = ({ 
  category, 
  data, 
  currencyRates, 
  loading, 
  onCopy, 
  copiedValue 
}) => {
  if (category === 'currency') {
    return (
      <CurrencyConverter
        currencyRates={currencyRates}
        loading={loading}
        onCopy={onCopy}
        copiedValue={copiedValue}
      />
    );
  }

  return (
    <UnitConverter
      category={category}
      data={data}
      onCopy={onCopy}
      copiedValue={copiedValue}
    />
  );
};

export default ConversionPanel;